<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    <div :class="{'has-error':errors.conversationId}">
      <label>Select a conversation to close:</label>
      <select :value="conversationId" name="conversationId" class="form-control" @change="handleChange">
        <option disabled value="">
          Select Conversation:
        </option>
        <option v-for="conversation in filteredConversations" :value="conversation.id">
          {{ conversation.name }}
        </option>
      </select>
    </div>
  </div>
</template>
<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

  export default {
    extends: BaseComponent,
    props: {
      id: String,
      conversationId: String,
    },
    computed: {
      filteredConversations() {
        return this.config.studyConversations;
      }
    },
    methods: {
      validate: function() {
        this.errors = {};

        if (!this.isNumber(this.conversationId)) {
          this.errors.conversationId = "Please select a conversation.";
        }

        return Object.keys(this.errors).length === 0;
      }
    }
  };
</script>
